import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import useResourceMutation from 'dpl/shared/fetching/hooks/useResourceMutation';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import {
  paymentRequestCategoryOptionsQueryDefinition,
  updatePaymentRequestMutationDefinition
} from '../utils/queryDefinitions';

export default function usePaymentRequest({ paymentRequestExternalId }) {
  const currentUser = useCurrentUser();
  const buyerProfileId = currentUser?.value?.data?.buyer_profile_id;

  const {
    value: { data: paymentRequestCategories },
    isSuccess: paymentRequestCategoryDataSuccess
  } = useResourceQuery(paymentRequestCategoryOptionsQueryDefinition);

  const {
    mutateAsync: updatePaymentRequest,
    isLoading: paymentRequestUpdating
  } = useResourceMutation(
    updatePaymentRequestMutationDefinition(
      buyerProfileId,
      paymentRequestExternalId
    )
  );

  return {
    paymentRequestCategories,
    paymentRequestCategoryDataSuccess,
    paymentRequestUpdating,
    updatePaymentRequest
  };
}
